import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import App from './App';
import { cacheKeys } from './constants/storageKeys';
import './index.css';
import { PCStoreJsBridge } from './nativeapi';
import rootReducer from './reducers';
import rootSaga from './sagas/index';
import { registerToken, logInit } from './utils/utils';
import KeepAlive, { AliveScope } from 'react-activation';

const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(rootSaga);

// 模拟器计时器对象
window.SIMTime = {};
// 开启是否可以拖动大小
window.PcstoreCanChangeSize = true;
// window.PcstoreCanChangeSize = false;

// 接收来自 native 的消息
window.CallJsProtoMethod = message => {
  const msg = PCStoreJsBridge.base64ToArrayBuffer(message);
  // 发布消息
  PCStoreJsBridge.publishMessage(msg);
};
//
if (!window.CallNativeMethod) {
  window.CallNativeMethod = () => {};
}

// 提前去获取机器信息和注册请求需要的TOKEN(暂定7天过期)
const machineInfoStr = localStorage.getItem(cacheKeys.LOCALMACHINE_INFO);
const token = localStorage.getItem(cacheKeys.REGISTER_TOKEN);
if (!machineInfoStr) {
  PCStoreJsBridge.getLocalMachineInfo().then(res => {
    logInit(res); // 拿到machineInfo就去注册打桩
    if (!token) {
      registerToken(res); // 拿着machineInfo注册token
    }
  });
} else {
  const machineInfo = JSON.parse(machineInfoStr);
  logInit(machineInfo); // 拿到machineInfo就去注册打桩
  if (!token) {
    registerToken(machineInfo); // 拿着machineInfo注册token
  }
}

// 还是重新获取一次machineInfo，避免区分独立包打桩问题。
PCStoreJsBridge.getLocalMachineInfo().then(res => {
  localStorage.setItem(cacheKeys.LOCALMACHINE_INFO, JSON.stringify(res));
});

// 提前去获取StartInfo（sessionId）后面好用
PCStoreJsBridge.getStartInfo();

ReactDOM.render(
  <Provider store={store}>
    <AliveScope>
      <App />
    </AliveScope>
  </Provider>,
  document.getElementById('root'),
);
